import React from 'react';
import { connect } from 'react-redux';
import Newsletter from './Newsletter';
import s from './Footer.scss';

const Footer = ({ newsletter, setup, properties }) => {
	return (
		<div className={s.footer}>
			<Newsletter newsletter={newsletter} setup={setup} properties={properties} />
		</div>
	);
};

const mapState = ({ environment }) => {
	const { properties, setup, newsletter } = environment;
	return { properties, setup, newsletter };
};

export default connect(mapState)(Footer);
